import { ASSETS } from "@/lib/assets";

export const LogoMark = ({ className = "w-8 h-8" }) => (
  <img
    src={ASSETS.logoMark}
    alt="NIGAMAI"
    className={`${className} rounded-lg object-cover ring-1 ring-[#00FF66]/40`}
    data-testid="logo-mark"
  />
);

export const LogoLockup = ({ mark = "w-8 h-8", text = "text-xl" }) => (
  <div className="flex items-center gap-2">
    <LogoMark className={mark} />
    <span className={`font-heading font-extrabold ${text} tracking-tighter text-white`}>
      NIGAM<span className="text-[#00FF66]">AI</span>
    </span>
  </div>
);
